<template>
  <div class="create-post-comp">
    <div class="d-flex align-items-center mb-5 mob-shadow">
      <font-awesome-icon
        :icon="['far', 'arrow-left']"
        class="cp gray400 mr-4"
        @click="changeScreen('back')"
      />
      <h4 class="fw700 font24 gray700 ml-1 mb-0">How are you feeling?</h4>
      <font-awesome-icon
        size="2x"
        :icon="['fal', 'times']"
        class="font-black ml-auto cp font20"
        @click="hide"
      />
    </div>
    <div class="feelingsContainer">
      <div
        v-for="feeling in typesOfFeelings"
        :key="feeling.name"
        class="d-flex align-items-center br8 p-2 font12 cp"
        :style="{
          background: selectedFeeling.name === feeling.name ? getPrimaryColor() : '#F8FAFD',
          color: selectedFeeling.name === feeling.name ? '#ffffff' : '#647490;',
        }"
        @click="changeScreen('add', 'feeling', feeling)"
      >
        <img
          :src="require(`../../../assets/emojis/${feeling.icon}.png`)"
          :alt="feeling.name"
          class="hw24 mr-2"
        />
        {{ feeling.name }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FeelingsScreen",
  props: { changeScreen: Function, selectedFeeling: String, hide: Function },
  data() {
    return {
      typesOfFeelings: [
        { name: "Happy", icon: "happy-40" },
        { name: "Blessed", icon: "Blessed-24" },
        { name: "Loved", icon: "Loved-24" },
        { name: "Angry", icon: "angry-40" },
        { name: "Amazing", icon: "Amazing-24" },
        { name: "Crazy", icon: "Crazy-24" },
        { name: "Tired", icon: "Tired-24" },
        { name: "Festive", icon: "Festive-24" },
        { name: "Scared", icon: "Scared-24" },
        { name: "Emotional", icon: "emotional-40" },
        { name: "Cool", icon: "Cool-24" },
        { name: "Confident", icon: "Confident-24" },
        { name: "Speachless", icon: "Speachless-24" },
        { name: "In Love", icon: "inlove-24" },
        { name: "Injured", icon: "Injured-24" },
        { name: "Cold", icon: "Cold-24" },
        { name: "Sick", icon: "Sick-24" },
        { name: "Hot", icon: "hot-24" },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.feelingsContainer {
  display: grid;
  gap: 8px 24px;
  grid-template-columns: 1fr 1fr;
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
.font12 {
  &:hover {
    background: #cbd5e1 !important;
  }
}
.mb-5 {
  @media screen and (max-width: 600px) {
    margin-bottom: 24px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/createNewPost/Feelings.vue